module.exports = __webpack_public_path__ + "baf7bf753c.jpg";